export const NEW_ACCOUNT_IDENTIFIER = 'NEW_ACCOUNT_IDENTIFIER';
export const MOBILE_APP_OPENID_REDIRECT_HOSTNAME = 'app.famly.co';
export const MOBILE_APP_OPENID_REDIRECT_PATHNAME = '/app-trap';
export const SELECTED_ACCOUNT_LOCAL_STORAGE_KEY = 'selectedAccount';
export const LANGUAGE_KNOWN_FROM_LOGIN_LOCAL_STORAGE_KEY = 'languageKnownFromLogin';
